<template>
  <div class="hello">
    <el-row>
      <el-col style="padding: 0 10px; box-sizing: border-box" :span="12">
        <div class="tablePlu">
          <p style="margin-bottom: 10px">{{$t('DriverManagement.form.allDriver')}}</p>
          <el-input
            @keyup.enter.native="getCarNew"
            size="small"
            v-model="searchValue"
            :placeholder="$t('common.searchTip')"
          ></el-input>
          <el-table
            v-loading="loading"
            stripe
            ref="multipleTable"
            :row-key="getRowKeys"
            @selection-change="leftChange"
            height="300"
            border
            :data="tableData"
            style="width: 100%"
          >
            <el-table-column
              :reserve-selection="reserve"
              align="center"
              type="selection"
              width="55"
            ></el-table-column>
            <el-table-column
              align="center"
              :label="$t('common.id')"
              type="index"
              width="50"
            ></el-table-column>
            <el-table-column
              align="center"
              prop="driverNum"
              :label="$t('common.driverNum')"
            ></el-table-column>
            <el-table-column
              align="center"
              prop="driverName"
              :label="$t('common.driverName')"
            ></el-table-column>
            <!-- <el-table-column
              align="center"
              prop="fingerNumV2"
              :label="$t('DriverManagement.authorizes')"
            ></el-table-column> -->
          </el-table>
        </div>
        <iPagination
          ref="page"
          :isize="small"
          @PageFun="changeSize"
        ></iPagination>
        <el-button @click="pitchUp" size="small" type="primary">{{$t('common.btn.confirm')}}</el-button>
      </el-col>
      <el-col style="padding: 0 10px; box-sizing: border-box" :span="12">
        <div class="tablePlu">
          <p style="margin-bottom: 10px">{{$t('DriverManagement.form.choseDriver')}}</p>
          <el-input
            @keyup.enter.native="getCarSearch"
            style="width: 50% !important; margin-bottom: 10px"
            size="small"
            v-model="input"
            :placeholder="$t('common.searchTip')"
          ></el-input>
          <el-table
          ref="rightRef"
            stripe
            @selection-change="RightChange"
            height="300"
            border
            :data="checkedTable"
            style="width: 100%"
          >
            <el-table-column
              align="center"
              type="selection"
              width="55"
            ></el-table-column>
            <el-table-column
              align="center"
              :label="$t('common.id')"
              type="index"
              width="50"
            ></el-table-column>
            <el-table-column
              align="center"
              prop="driverNum"
              :label="$t('common.driverNum')"
            ></el-table-column>
            <el-table-column
              align="center"
              prop="driverName"
              :label="$t('common.driverName')"
            ></el-table-column>
            <!-- <el-table-column
              align="center"
              prop="fingerNumV2"
              :label="$t('DriverManagement.authorizes')"
            ></el-table-column> -->
          </el-table>
        </div>
        <el-button
          style="margin-top: 10px"
          @click="deleteList"
          size="small"
          type="danger"
          >{{$t('common.btn.delete')}}</el-button
        >
      </el-col>
    </el-row>
  </div>
</template>
<script>
import iPagination from "../../../../components/pagination.vue";
export default {
  components: {
    iPagination,
  },
  data() {
    return {
      dialogVisible: false,
      searchValue: "",
      input: "",
      reserve: false,
      loading: false,
      tableData: [],
      checkedTable: [],
      selected: [],
      rightSelect: [],
      currentPage1: 1,
      pageNum: 1,
      small: true,
      pageSize: 10,
      getRowKeys(row) {
        return row.driverNum;
      },
      typeId: "",
    };
  },
  props: ["fingerGroupId"],
  created() {
  },
  mounted() {
    
  },
  methods: {
    getCarSearch() {
       var arr = this.checkedTable.filter((item) => {
        if(item.driverNum == this.input){
          return item
        }     
      });
      this.checkedTable = arr
    },
    getCarNew() {
      this.pageSize = 10;
      this.pageNum = 1;
      this.getDriver();
    },
    getDriver() {
      this.loading = true;
      let param = {
        orgId: this.orgId,
        driverNum: this.searchValue,
        pageSize: this.pageSize,
        pageNum: this.pageNum,
      };
      this.$store.dispatch("DriverFingerprintFile/GET_SELECTDRIVERFINGER", param).then((res) => {
        console.log(res)
          if (res.data.code == 200) {
            this.tableData = res.data.data.list;
            this.$refs.page.CommandTotal = res.data.data.total;
          } else {
            this.$message.error(res.msg);
          }
          this.loading = false;
        })
        .catch((err) => {
          this.loading = false;
        });
    },
    changeSize(item) {
      this.pageNum = item.pageNum;
      this.pageSize = item.pageSize;
      this.getDriver();
    },
    getRightData() {
      let param = {
        selectType: 2,
        fingerGroupId: this.fingerGroupId
      };
      this.$store.dispatch("DriverFingerprintFile/GET_SELECTCHECKEDDRIVER", param).then((res) => {
          if (res.data.code == 200) {
            this.checkedTable = res.data.data;
            this.$nextTick(() => {
              this.checkedTable.map((item) => {
                  this.$refs.rightRef.toggleRowSelection(item);
               });
            })
          } else {
            this.$message.error(res.msg);
          }
        })
        .catch((err) => {
          
        });
    },
    
    deleteList() {
      this.rightSelect.map((item, t) => {
        this.checkedTable.map((items, index) => {
          if (items.driverNum == item.driverNum) {
            this.checkedTable.splice(index, 1);
            this.$refs.multipleTable.toggleRowSelection(item, false);
          }
        });
      });
      this.$emit("adminParam", this.checkedTable);
    },
    
    RightChange(selected) {
      this.rightSelect = selected;
    },
   
    pitchUp(data) {
      if(this.checkedTable.length > 0) {
        const arr = this.selected.concat(this.checkedTable)
        console.log(arr)
        const res = new Map()
        const checkList = arr.filter(
           (item) => !res.has(item.driverNum) && res.set(item.driverNum, 1)
        );
        this.checkedTable = checkList;
      } else {
        this.checkedTable = this.selected;
      }
      data = this.checkedTable
      this.$emit("adminParam", data);
      
    },
    leftChange(selected) {
      this.selected = selected;
    },
  },
};
</script>

<style lang='less' scoped>
@import "../../../../assets/styles/command.less";
.el-table__body,
.el-table__footer,
.el-table__header {
  border-collapse: collapse;
}
.el-checkbox__input.is-disabled.is-checked .el-checkbox__inner {
  background-color: #f2f6fc !important;
  border-color: #dcdfe6 !important;
}
</style>
